import { render, staticRenderFns } from "./OrganizationsRequests.vue?vue&type=template&id=936b0e78&"
import script from "./OrganizationsRequests.vue?vue&type=script&lang=js&"
export * from "./OrganizationsRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports